<div class="ai-quote-form-container">
  <div class="form-description">
    {{ quoteFormRequest?.title }}
  </div>

  @if (!isReadOnly) {
    <div class="form-wrapper">
      <form [formGroup]="quoteForm" (ngSubmit)="onSubmit()" class="ai-quote-form">
        @for (section of sections; track section) {
          <div>
            <div class="section-header">
              <span>{{ section.title }}</span>
            </div>
            <div class="section-body">
              @for (field of section.fields; track field) {
                <div>
                  @switch (field.type) {
                    @case (questionType.RADIO) {
                      <div class="radio-options-container">
                        @for (option of field.options; track option) {
                          <div class="radio-option">
                            <input type="radio" class="radio-input" [name]="field.name"
                              [checked]="isSelected(field.name, option.value)"
                              (change)="onSelectionChange(field.name, option.value)"
                              [disabled]="isReadOnly || quoteForm.disabled">
                            <span class="option-label">{{ option.label }}</span>
                          </div>
                        }
                      </div>
                    }
                    @default {
                      <div class="field-label">{{ field.label }}</div>
                      <div class="input-wrapper">
                        <input class="text-input"
                          [type]="field.type === questionType.NUMBER ? 'number' : 'text'"
                          [placeholder]="field.placeholder" [formControlName]="field.name"
                          [required]="field.required" [disabled]="isReadOnly">
                        @if (isFieldInvalid(field.name)) {
                          <span class="validation-icon-container">
                            <span #tooltipRef="matTooltip"
                              (click)="isMobileApp && showTooltipForMobile(tooltipRef)"
                              [matTooltip]="getFieldErrorTooltip(field.name)"
                              matTooltipPosition="above"
                              class="validation-icon"
                              matTooltipClass="ai-chat-form-field-validation-tooltip">
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg" class="error-svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M7.00004 0.454529C3.38509 0.454529 0.45459 3.38503 0.45459 6.99998C0.45459 10.6149 3.38509 13.5454 7.00004 13.5454C10.615 13.5454 13.5455 10.6149 13.5455 6.99998C13.5455 3.38503 10.615 0.454529 7.00004 0.454529ZM6.9147 11.3637C7.61962 11.3637 8.19311 10.7902 8.19311 10.0853C8.19311 9.38035 7.61962 8.80686 6.9147 8.80686C6.20979 8.80686 5.63629 9.38035 5.63629 10.0853C5.63629 10.7902 6.20979 11.3637 6.9147 11.3637ZM6.0016 7.93113L5.78427 3.58454C5.77332 3.36547 5.94797 3.18186 6.16731 3.18186H7.66209C7.88144 3.18186 8.05608 3.36547 8.04514 3.58454L7.82781 7.93113C7.81759 8.13525 7.64913 8.29549 7.44476 8.29549H6.38464C6.18027 8.29549 6.01181 8.13525 6.0016 7.93113Z"
                                  fill="#FF3A42"/>
                              </svg>
                            </span>
                          </span>
                        }
                      </div>
                    }
                  }
                  @if (isFieldInvalid(field.name)) {
                    <div class="field-error">
                      {{ getFieldErrorTooltip(field.name) }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        <div class="action-button-container">
          @if(!hideCancelButton) {
          <button type="button" class="action-btn" (click)="cancel()">
            {{ quoteFormRequest?.cancelLabel || 'CANCEL' }}
          </button>
          }
          <button type="submit" class="action-btn" [disabled]="quoteForm.invalid">
            {{ quoteFormRequest?.submitLabel || 'SUBMIT' }}
          </button>
        </div>
      </form>
    </div>
  }

  @if (isReadOnly) {
    <div>
      <div class="selected-value-container">
        @for (section of sections; track section) {
          <div class="selected-section">
            @for (field of section.fields; track field) {
              <div class="selected-field-row">
                <div class="selected-field-label">{{ field.label }}</div>
                <div class="selected-field-value">
                  @if (hasReadOnlyValue(field.name)) {
                    @switch (field.type) {
                      @case (questionType.RADIO) {
                        @for (option of field.options; track option) {
                          @if (isSelected(field.name, option.value)) {
                            <div class="selected-option-item">
                              <span>{{ option.label }}</span>
                            </div>
                          }
                        }
                      }
                      @default {
                        <span>{{ quoteForm.value?.[field.name] }}</span>
                      }
                    }
                  } @else {
                    @switch (field.type) {
                      @case (questionType.RADIO) {
                        <div class="radio-options-container readonly-options">
                          @for (option of field.options; track option) {
                            <div class="radio-option readonly-option">
                              <input type="radio" class="radio-input" [name]="field.name"
                                [checked]="false" disabled>
                              <span class="option-label">{{ option.label }}</span>
                            </div>
                          }
                        </div>
                      }
                      @default {
                        <input class="text-input readonly-input"
                          [type]="field.type === questionType.NUMBER ? 'number' : 'text'"
                          [placeholder]="field.placeholder" disabled>
                      }
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
